var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoUpArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "9px",
    viewBox: "0 0 16 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help",
    transform: "translate(-408.000000, -585.000000)",
    fill: "#023860",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.334735,585.329505 C408.776447,584.894694 409.489775,584.890212 409.937088,585.316057 L409.950979,585.329505 L416,591.284016 L422.049021,585.329505 C422.490733,584.894694 423.204061,584.890212 423.651374,585.316057 L423.665265,585.329505 C424.106977,585.764315 424.111531,586.466497 423.678926,586.906821 L423.665265,586.920495 L416.808122,593.670495 C416.36641,594.105306 415.653082,594.109788 415.205769,593.683943 L415.191878,593.670495 L408.334735,586.920495 C407.888422,586.481155 407.888422,585.768845 408.334735,585.329505 Z",
    id: "Path-Copy-7",
    transform: "translate(416.000000, 589.500000) rotate(-180.000000) translate(-416.000000, -589.500000) "
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoUpArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-up-arrow-icon.ac2d8271e975f33044754eb015fd80c4.svg";